import { Chip, Grid2, Tab, Tabs, Typography } from "@mui/material";
import Container from "../../../components/Container";
import { useEffect, useMemo, useState } from "react";
import api from "../../../utils/axios";
import { ITransaction } from "sierra";
import StyledDataGrid from "../../../components/StyledDataGrid";
import DataGridSkeleton from "../../../components/Skeletons/DataGridSkeleton";
import getTransactionStatus from "../../../utils/getTransactionStatus";
import { useApp } from "../../../contexts/AppContext";

export default function SystemTransactions() {
    const { translate, lang } = useApp()

    const [transactions, setTransactions] = useState<Required<ITransaction>[]>()
    const [tab, setTab] = useState<'all' | 'successful' | 'declined' | 'cancelled' | 'error' | 'expired'>('all')

    useEffect(() => {
        fetchTransactions()
    }, [])

    const fetchTransactions = () => {
        api.get('/payments').then(({ data }) => setTransactions(data)).catch(console.error)
    }

    const filteredTransactions = useMemo(() => transactions?.filter(t => {
        if (tab === 'all') return true;
        else if (tab === 'successful') return t.status === 'A'
        else if (tab === 'cancelled') return t.status === 'C'
        else if (tab === 'declined') return t.status === 'D'
        else if (tab === 'error') return t.status === 'E'
        else if (tab === 'expired') return t.status === 'X'
    }), [transactions, tab])


    const columns = [{
        field: 'paytabs_ref',
        headerName: translate('Trx ID'),
        minWidth: 150,
        flex: 0.7,
    }, {
        field: 'order_id',
        headerName: translate('Order ID'),
        minWidth: 75,
        flex: 0.4,
    }, {
        field: 'user',
        headerName: translate('Customer'),
        minWidth: 150,
        flex: 1,
        valueGetter: (value: { user_id: number, name: string }) => {
            return `${value.name} (#${value.user_id})`
        }
    }, {
        field: 'amount',
        headerName: translate('Amount'),
        minWidth: 150,
        flex: 0.7,
        renderCell: ({ row }: { row: ITransaction }) => {
            return `${row.currency} ${(row.amount / 100).toFixed(2)}`
        }
    }, {
        field: 'status',
        headerName: translate('Status'),
        minWidth: 100,
        flex: 0.5,
        renderCell: ({ row: { status } }: { row: ITransaction }) => (
            <Chip variant="outlined" color={status === 'A' ? 'success' : status === 'D' ? 'warning' : status === 'E' ? 'error' : undefined} label={translate(getTransactionStatus(status))} />
        )
    },
    {
        field: 'creation_timestamp',
        headerName: translate('Date/Time'),
        minWidth: 150,
        flex: 0.7,
        valueGetter: (value: Date) => {
            return new Date(value).toLocaleString(lang === 'ar' ? 'ar-SD' : undefined)
        },
    }
    ];

    return (
        <Grid2 container size={'grow'} spacing={2} flexDirection={'column'}>

            <Container container size={'auto'} padding={2} justifyContent={'space-between'}>
                <Grid2>
                    <Typography variant='h4' fontWeight={'bold'} color='primary'>
                        {translate("Transactions")}
                    </Typography>
                </Grid2>
            </Container>

            <Container padding={2} width={'100%'} size='auto'>
                <Grid2>
                    <Tabs variant='scrollable' value={tab} onChange={(_, v) => setTab(v)}>
                        <Tab label={translate('All')} value={'all'} />
                        <Tab label={translate('Successful')} value={'successful'} />
                        <Tab label={translate('Declined')} value={'declined'} />
                        <Tab label={translate('Cancelled')} value={'cancelled'} />
                        <Tab label={translate('Error')} value={'error'} />
                        <Tab label={translate('Expired')} value={'expired'} />
                    </Tabs>
                </Grid2>
            </Container>

            <Container container flexDirection={'column'} flexWrap={'nowrap'} overflow={'auto'} spacing={2} padding={2} sx={{ direction: 'ltr' }}>

                {
                    !filteredTransactions ? <DataGridSkeleton /> :
                        filteredTransactions.length == 0 ?
                            <Typography>{translate("No transactions to show")}</Typography> :
                            <StyledDataGrid
                                rowSpacingType={'margin'}
                                rows={filteredTransactions.map((c, i) => ({ ...c, id: i }))}
                                columns={columns}
                                disableRowSelectionOnClick
                            // sx={{
                            //     '& .MuiDataGrid-row.A': generateRowClass(Colors.green[100]),
                            //     '& .MuiDataGrid-row.D': generateRowClass(Colors.blue[100]),
                            //     '& .MuiDataGrid-row.completed': generateRowClass(Colors.green[100]),
                            //     '& .MuiDataGrid-row.awaiting': generateRowClass(Colors.orange[100]),
                            //     '& .MuiDataGrid-row.cancelled': generateRowClass(Colors.red[200]),
                            //     '& .MuiDataGrid-row.validating': generateRowClass(Colors.yellow[100]),
                            //     '& .MuiDataGrid-row:hover': {
                            //         cursor: 'pointer'
                            //     }
                            // }}
                            />

                }
            </Container>

        </Grid2>
    )
}